import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { SearchConditionsButton, SearchSortDialog } from '../molecules';
export const SelectOption = {
    NewArrival: 'new_arrival',
    Favorite: 'favorite',
    LengthLonger: 'length_longer',
    LengthShorter: 'length_shorter',
    Easy: 'easy',
    Difficult: 'difficult',
};
export const selectOptions = [
    {
        value: SelectOption.Favorite,
        name: '人気順',
    },
    {
        value: SelectOption.NewArrival,
        name: '新着順',
    },
    {
        value: SelectOption.LengthLonger,
        name: '時間が長い順',
    },
    {
        value: SelectOption.LengthShorter,
        name: '時間が短い順',
    },
    {
        value: SelectOption.Easy,
        name: '簡単順',
    },
    {
        value: SelectOption.Difficult,
        name: '難しい順',
    },
];
export const SearchConditionsButtonWithDialog = ({ label, currentValue, onChangeSort }) => {
    const [showSortDialog, setShowSortDialog] = React.useState(false);
    const [sortBy, setSortBy] = React.useState(currentValue);
    const onClickButton = () => {
        setShowSortDialog(true);
    };
    const submitSortDialogHandler = () => {
        onChangeSort(sortBy);
        setShowSortDialog(false);
    };
    const cancelSortDialogHandler = () => {
        setShowSortDialog(false);
    };
    return (React.createElement("div", { className: css(styles.container) },
        React.createElement("div", { className: css(styles.searchConditionsContainer) },
            React.createElement(SearchConditionsButton, { label: label, enteredForButtonColor: false, onClick: onClickButton })),
        showSortDialog && (React.createElement(SearchSortDialog, { currentValue: sortBy, setCurrentValue: setSortBy, onClickSubmit: submitSortDialogHandler, onClickCancel: cancelSortDialogHandler }))));
};
const styles = StyleSheet.create({
    container: {},
    searchConditionsContainer: {
        display: 'flex',
        maxWidth: 800,
    },
});
